const devmode = false;

module.exports = {
    name: 'cg-upload-game',
    deps: [
        'ui.router'
    ],
    states: {
        "main": {
            route: {
                url: '',
                abstract: true,
                views: {
                    main: {
                        template: require('./states/main/index.html'),
                        controller: require('./states/main')
                    }
                }
            }
        },
        "main.city": {
            route: {
                url: '/ville',
                views: {
                    main: {
                        template: require('./states/main.city/index.html'),
                        controller: require('./states/main.city')
                    }
                }
            }
        },
        "main.intro": {
            route: {
                url: '/intro',
                views: {
                    main: {
                        template: require('./states/main.intro/index.html'),
                        controller: require('./states/main.intro')
                    }
                }
            }
        },
        "main.end": {
            route: {
                url: '/fin',
                views: {
                    main: {
                        template: require('./states/main.end/index.html'),
                        controller: require('./states/main.end')
                    }
                }
            }
        }
    },
    services: [
        require('./engine'),
        require('./services/gamelog') 
    ],
    directives: [

    ],
    filters: [ 
        require('./filters/unsafe'),
        require('./filters/mdlink'),
        require('./filters/hours')
    ]
};